<template>
	<div id="withdraw " class="page" 
		title="加载"
		v-infinite-scroll="loadMore"
		infinite-scroll-disabled="loading"
		infinite-scroll-distance="50">
		<div class='fenxiao-order'>
			<div class='order-list' v-for="item in orderList">
				<div class='top'>
					<span>订单号：{{item.order_sn}}</span>
					<span class='right'>￥{{item.total_price}}</span>
				</div>
				<div class='bottom'>
					<div class='left'>
						<img v-bind:src="item.avatar"/>
						<span>{{item.nickname}}</span>
					</div>
					<div class='middle'>
						<span>{{item.driving_level}}</span>
					</div>
					<div class='right'>
						预计收益：<span>￥{{item.estimate_money}}</span>
					</div>
				</div>
				<div class='top' style="border-top:1px solid #ededed;">
					<span>成交时间：</span>
					<span class='right' style="color:#7D7D7D;">{{item.pay_time}}</span>
				</div>
			</div>
		</div>
		<p v-show="loading" class="loading-tips" style="text-align:center;">
			<wv-spinner type="snake" color="#444" :size="24"/>
		</p>
	</div>
</template>

<script>
import { Toast , Dialog} from 'we-vue'
export default {
	data () {
		return {
			loaded:false,
			orderList:[],
			loading:false,
			page:1
		}
	},
	created () {
		
	},
	methods: {
		loadMore(){
			if(this.loaded){
				return false
			}
			this.loading = true
			this.$https.post("/api/order/lists",this.$qs.stringify({
				token:this.$store.state.token,
				page:this.page
			})).then((res) => {
				if(res.data.data.length < 1){
					this.loaded = true;
				}
				for(var n in res.data.data){
					this.orderList.push(res.data.data[n])
				}
				this.loading = false
				this.page++;
			}).catch(() => {
				
			});
		}
	},
	filters: {
    
	}
}
</script>

<style scoped>
	#withdraw{
		background-color:#ffffff;
		min-height:100vh;
	}
.order-list{
  margin-bottom: 10px;
  background: #fff;
}
.order-list .top{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ededed;
  font-size: 14px;
  padding: 10px;
}
.order-list .top .right{
  color: #eb6100;
}
.order-list .bottom{
  display: flex;
  padding: 10px;
  align-items: center;
  font-size: 14px;
}
.order-list .bottom div{
  text-align: center;
}
.order-list .bottom .left{
  text-align: left;
  display: flex;
  align-items: center;
   flex: 2;
}
.order-list .bottom .middle{
  flex: 1;
}
.order-list .bottom .right{
  flex: 2;
}
.order-list .bottom .right span{
  color: #eb6100;
}
.order-list .bottom .left img{
  width: 60px;
  height: 60px;
  border-radius: 100%;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Dorder.vue